var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.gasTurbines.length > 0
        ? _c(
            "pui-form-group",
            {
              staticClass: "unit_group mb-1",
              attrs: {
                label:
                  _vm
                    .$t(
                      "operationalData.entryView.tabs.componentsTab.gasTurbine"
                    )
                    .toString()
                    .toUpperCase() + " :",
                "has-label-padding": false,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, m: 12, l: 12 },
                      expression: "{ s: 12, m:12, l: 12 }",
                    },
                  ],
                  staticClass: "building-block",
                },
                [
                  _vm._l(_vm.gasTurbines, function (turbine, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("ComponentsBlock", {
                          attrs: { data: turbine, index: index },
                        }),
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "mb-3" }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.steamTurbines.length > 0
        ? _c(
            "pui-form-group",
            {
              staticClass: "unit_group mb-1",
              attrs: {
                label:
                  _vm
                    .$t(
                      "operationalData.entryView.tabs.componentsTab.steamTurbine"
                    )
                    .toString()
                    .toUpperCase() + " :",
                "has-label-padding": false,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, m: 12, l: 12 },
                      expression: "{ s: 12, m:12, l: 12 }",
                    },
                  ],
                  staticClass: "building-block",
                },
                [
                  _vm._l(_vm.steamTurbines, function (turbine, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("ComponentsBlock", {
                          attrs: { data: turbine, index: index },
                        }),
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "mb-3" }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.boilers.length > 0
        ? _c(
            "pui-form-group",
            {
              staticClass: "unit_group",
              attrs: {
                label:
                  _vm
                    .$t("operationalData.entryView.tabs.componentsTab.boiler")
                    .toString()
                    .toUpperCase() + " :",
                "has-label-padding": false,
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: { s: 12, m: 12, l: 12 },
                      expression: "{ s: 12, m:12, l: 12 }",
                    },
                  ],
                  staticClass: "building-block",
                },
                [
                  _vm._l(_vm.boilers, function (boiler, index) {
                    return _c(
                      "div",
                      { key: index },
                      [
                        _c("ComponentsBlock", {
                          attrs: { data: boiler, index: index },
                        }),
                      ],
                      1
                    )
                  }),
                  _c("div", { staticClass: "mb-3" }),
                ],
                2
              ),
            ]
          )
        : _vm._e(),
      _vm.gasTurbines.length == 0 &&
      _vm.steamTurbines.length == 0 &&
      _vm.boilers.length == 0
        ? _c("pui-form-group", {
            staticClass: "unit_group",
            attrs: {
              label: _vm
                .$t("operationalData.entryView.tabs.componentsTab.noComponents")
                .toString(),
              "has-label-padding": false,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }